import React, { Component } from 'react';
// import cx from 'classnames';
import styles from './_desktopContactUs.module.scss';

export default class DesktopContactUs extends Component {
  render() {
    return <div className={styles['desktop-contact-us']}>in progress</div>;
  }
}
